import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@svs/ui/react/button';
import ScrollDown from '@svs/ui/react/icons/ScrollDown';
import { useEffect, useState } from 'react';
const handleClick = (e, isScrollToBottomNeeded) => {
  /* Stop propagartion is used here to prevent click from bubbling up and opening bottom sheet when clicking pay button */
  e.stopPropagation();
  if (isScrollToBottomNeeded) {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
    /* Prevent default is used here to prevent form from submitting if scroll to bottom is needed */
    e.preventDefault();
  }
};
const useIsAtBottomWindow = () => {
  const $ = _c(2);
  const [isAtBottom, setIsAtBottom] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        const {
          offsetHeight,
          scrollTop
        } = document.documentElement;
        const {
          innerHeight
        } = window;
        const hasReachedBottom = offsetHeight - (innerHeight + scrollTop) <= 10;
        setIsAtBottom(hasReachedBottom);
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isAtBottom;
};
/**
 * BetslipPayButton component renders a submit (pay) button for the coupon.
 *
 * @param root0 input object
 * @param root0.hasAdditions the product has additions
 * @param root0.disabled whether the button should be disabled
 * @returns The submit (pay) button.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export default function BetslipPayButton(t0) {
  const $ = _c(7);
  const {
    hasAdditions,
    disabled
  } = t0;
  const isAtBottom = useIsAtBottomWindow();
  const isScrollToBottomNeeded = !isAtBottom && hasAdditions;
  let label = "Betala";
  if (isScrollToBottomNeeded) {
    label = "Till betalning";
  }
  let t1;
  if ($[0] !== isScrollToBottomNeeded) {
    t1 = e => {
      handleClick(e, isScrollToBottomNeeded);
    };
    $[0] = isScrollToBottomNeeded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== isScrollToBottomNeeded || $[4] !== label || $[5] !== t1) {
    t2 = _jsxs(Button, {
      type: "submit",
      className: "h-8 px-2 py-1 text-sm [grid-area:payButton] lg:h-10 lg:px-3 lg:py-2 lg:text-base",
      form: "coupon_form",
      "aria-disabled": disabled,
      onClick: t1,
      variant: "primary",
      "data-testid": "payButton",
      children: [label, isScrollToBottomNeeded && _jsx(ScrollDown, {
        "aria-hidden": "true",
        className: "h-[24px] w-[24px]"
      })]
    });
    $[2] = disabled;
    $[3] = isScrollToBottomNeeded;
    $[4] = label;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}